import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b5497ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, [
    /*#__PURE__*/_createTextVNode("电站状态 "),
    /*#__PURE__*/_createElementVNode("span", { class: "info-icon" }, "?")
  ])
], -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = ["option"]
const _hoisted_5 = { class: "legend-grid" }
const _hoisted_6 = { class: "legend-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot",
  style: {"background-color":"#56d396"}
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "正常", -1))
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "legend-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot",
  style: {"background-color":"#ff4d4f"}
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "告警", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "legend-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot",
  style: {"background-color":"#ffc107"}
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "未监控", -1))
const _hoisted_17 = { class: "value" }

import { ref, computed, onMounted, watch } from 'vue'
import * as echarts from 'echarts'
interface StatusData {
  normal: number
  alarm: number
  unmonitored: number
  stationCount: number
}


export default /*#__PURE__*/_defineComponent({
  props: {
    statusData: null
  },
  setup(__props: any) {

const props = __props as {
  statusData: StatusData
}



const total = computed(() => props.statusData.stationCount)

const normalRate = computed(() => {
  if (total.value === 0) return 0
  return Math.round((props.statusData.normal / total.value) * 100)
})
const chart = ref()
onMounted(() => {
  if (chart.value) {
    const chartInstance = echarts.init(chart.value)
    chartInstance.setOption(chartOption.value)
  }
})
watch(normalRate, () => {
  if (chart.value) {
    const chartInstance = echarts.init(chart.value)
    chartInstance.setOption(chartOption.value)
  }
})
// ECharts 配置
const chartOption = computed(() => ({
  title: {
    text: `${normalRate.value}%`,
    subtext: '正常运行率',
    left: 'center',
    top: '38%',
    textStyle: {
      fontSize: 28,
      color: '#6563ff',
      fontWeight: 'bold',
    },
    subtextStyle: {
      fontSize: 14,
      color: '#909399',
    },
  },
  series: [
    {
      type: 'pie',
      radius: ['75%', '90%'],
      avoidLabelOverlap: false,
      hoverAnimation: false,
      label: {
        show: false,
      },
      data: [
        {
          value: props.statusData.normal,
          itemStyle: {
            color: '#6563ff',
          },
        },
        {
          value: props.statusData.normal == 0 ? 1 : total.value - props.statusData.normal,
          itemStyle: {
            color: '#eef2f8',
          },
        },
      ],
    },
  ],
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        ref_key: "chart",
        ref: chart,
        class: "chart",
        option: _unref(chartOption),
        autoresize: ""
      }, null, 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, _toDisplayString(__props.statusData.normal), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("span", _hoisted_13, _toDisplayString(__props.statusData.alarm), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _hoisted_16,
          _createElementVNode("span", _hoisted_17, _toDisplayString(__props.statusData.unmonitored), 1)
        ])
      ])
    ])
  ]))
}
}

})